/**
 * @fileoverview gRPC-Web generated client stub for saufdings
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.29.0
// source: bpong.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var user_pb = require('./user_pb.js')
const proto = {};
proto.saufdings = require('./bpong_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.saufdings.PongerClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.saufdings.PongerPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.RuleProt,
 *   !proto.saufdings.Rules>}
 */
const methodDescriptor_Ponger_GetRules = new grpc.web.MethodDescriptor(
  '/saufdings.Ponger/GetRules',
  grpc.web.MethodType.UNARY,
  proto.saufdings.RuleProt,
  proto.saufdings.Rules,
  /**
   * @param {!proto.saufdings.RuleProt} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.Rules.deserializeBinary
);


/**
 * @param {!proto.saufdings.RuleProt} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.Rules)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.Rules>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.PongerClient.prototype.getRules =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.Ponger/GetRules',
      request,
      metadata || {},
      methodDescriptor_Ponger_GetRules,
      callback);
};


/**
 * @param {!proto.saufdings.RuleProt} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.Rules>}
 *     Promise that resolves to the response
 */
proto.saufdings.PongerPromiseClient.prototype.getRules =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.Ponger/GetRules',
      request,
      metadata || {},
      methodDescriptor_Ponger_GetRules);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.CreateTournamentRequest,
 *   !proto.saufdings.Tournament>}
 */
const methodDescriptor_Ponger_CreateTournament = new grpc.web.MethodDescriptor(
  '/saufdings.Ponger/CreateTournament',
  grpc.web.MethodType.UNARY,
  proto.saufdings.CreateTournamentRequest,
  proto.saufdings.Tournament,
  /**
   * @param {!proto.saufdings.CreateTournamentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.Tournament.deserializeBinary
);


/**
 * @param {!proto.saufdings.CreateTournamentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.Tournament)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.Tournament>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.PongerClient.prototype.createTournament =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.Ponger/CreateTournament',
      request,
      metadata || {},
      methodDescriptor_Ponger_CreateTournament,
      callback);
};


/**
 * @param {!proto.saufdings.CreateTournamentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.Tournament>}
 *     Promise that resolves to the response
 */
proto.saufdings.PongerPromiseClient.prototype.createTournament =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.Ponger/CreateTournament',
      request,
      metadata || {},
      methodDescriptor_Ponger_CreateTournament);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.GetTournamentRequest,
 *   !proto.saufdings.Tournament>}
 */
const methodDescriptor_Ponger_GetTournament = new grpc.web.MethodDescriptor(
  '/saufdings.Ponger/GetTournament',
  grpc.web.MethodType.UNARY,
  proto.saufdings.GetTournamentRequest,
  proto.saufdings.Tournament,
  /**
   * @param {!proto.saufdings.GetTournamentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.Tournament.deserializeBinary
);


/**
 * @param {!proto.saufdings.GetTournamentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.Tournament)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.Tournament>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.PongerClient.prototype.getTournament =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.Ponger/GetTournament',
      request,
      metadata || {},
      methodDescriptor_Ponger_GetTournament,
      callback);
};


/**
 * @param {!proto.saufdings.GetTournamentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.Tournament>}
 *     Promise that resolves to the response
 */
proto.saufdings.PongerPromiseClient.prototype.getTournament =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.Ponger/GetTournament',
      request,
      metadata || {},
      methodDescriptor_Ponger_GetTournament);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.ListTournamentsRequest,
 *   !proto.saufdings.TournamentList>}
 */
const methodDescriptor_Ponger_ListTournaments = new grpc.web.MethodDescriptor(
  '/saufdings.Ponger/ListTournaments',
  grpc.web.MethodType.UNARY,
  proto.saufdings.ListTournamentsRequest,
  proto.saufdings.TournamentList,
  /**
   * @param {!proto.saufdings.ListTournamentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.TournamentList.deserializeBinary
);


/**
 * @param {!proto.saufdings.ListTournamentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.TournamentList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.TournamentList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.PongerClient.prototype.listTournaments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.Ponger/ListTournaments',
      request,
      metadata || {},
      methodDescriptor_Ponger_ListTournaments,
      callback);
};


/**
 * @param {!proto.saufdings.ListTournamentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.TournamentList>}
 *     Promise that resolves to the response
 */
proto.saufdings.PongerPromiseClient.prototype.listTournaments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.Ponger/ListTournaments',
      request,
      metadata || {},
      methodDescriptor_Ponger_ListTournaments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.UpdateMatchRequest,
 *   !proto.saufdings.Match>}
 */
const methodDescriptor_Ponger_UpdateMatch = new grpc.web.MethodDescriptor(
  '/saufdings.Ponger/UpdateMatch',
  grpc.web.MethodType.UNARY,
  proto.saufdings.UpdateMatchRequest,
  proto.saufdings.Match,
  /**
   * @param {!proto.saufdings.UpdateMatchRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.Match.deserializeBinary
);


/**
 * @param {!proto.saufdings.UpdateMatchRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.Match)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.Match>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.PongerClient.prototype.updateMatch =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.Ponger/UpdateMatch',
      request,
      metadata || {},
      methodDescriptor_Ponger_UpdateMatch,
      callback);
};


/**
 * @param {!proto.saufdings.UpdateMatchRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.Match>}
 *     Promise that resolves to the response
 */
proto.saufdings.PongerPromiseClient.prototype.updateMatch =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.Ponger/UpdateMatch',
      request,
      metadata || {},
      methodDescriptor_Ponger_UpdateMatch);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.UpdateTournamentRequest,
 *   !proto.saufdings.Tournament>}
 */
const methodDescriptor_Ponger_UpdateTournament = new grpc.web.MethodDescriptor(
  '/saufdings.Ponger/UpdateTournament',
  grpc.web.MethodType.UNARY,
  proto.saufdings.UpdateTournamentRequest,
  proto.saufdings.Tournament,
  /**
   * @param {!proto.saufdings.UpdateTournamentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.Tournament.deserializeBinary
);


/**
 * @param {!proto.saufdings.UpdateTournamentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.Tournament)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.Tournament>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.PongerClient.prototype.updateTournament =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.Ponger/UpdateTournament',
      request,
      metadata || {},
      methodDescriptor_Ponger_UpdateTournament,
      callback);
};


/**
 * @param {!proto.saufdings.UpdateTournamentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.Tournament>}
 *     Promise that resolves to the response
 */
proto.saufdings.PongerPromiseClient.prototype.updateTournament =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.Ponger/UpdateTournament',
      request,
      metadata || {},
      methodDescriptor_Ponger_UpdateTournament);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.EliminateTeamRequest,
 *   !proto.saufdings.Tournament>}
 */
const methodDescriptor_Ponger_EliminateTeam = new grpc.web.MethodDescriptor(
  '/saufdings.Ponger/EliminateTeam',
  grpc.web.MethodType.UNARY,
  proto.saufdings.EliminateTeamRequest,
  proto.saufdings.Tournament,
  /**
   * @param {!proto.saufdings.EliminateTeamRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.Tournament.deserializeBinary
);


/**
 * @param {!proto.saufdings.EliminateTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.Tournament)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.Tournament>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.PongerClient.prototype.eliminateTeam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.Ponger/EliminateTeam',
      request,
      metadata || {},
      methodDescriptor_Ponger_EliminateTeam,
      callback);
};


/**
 * @param {!proto.saufdings.EliminateTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.Tournament>}
 *     Promise that resolves to the response
 */
proto.saufdings.PongerPromiseClient.prototype.eliminateTeam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.Ponger/EliminateTeam',
      request,
      metadata || {},
      methodDescriptor_Ponger_EliminateTeam);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.ReinstateTeamRequest,
 *   !proto.saufdings.Tournament>}
 */
const methodDescriptor_Ponger_ReinstateTeam = new grpc.web.MethodDescriptor(
  '/saufdings.Ponger/ReinstateTeam',
  grpc.web.MethodType.UNARY,
  proto.saufdings.ReinstateTeamRequest,
  proto.saufdings.Tournament,
  /**
   * @param {!proto.saufdings.ReinstateTeamRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.Tournament.deserializeBinary
);


/**
 * @param {!proto.saufdings.ReinstateTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.Tournament)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.Tournament>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.PongerClient.prototype.reinstateTeam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.Ponger/ReinstateTeam',
      request,
      metadata || {},
      methodDescriptor_Ponger_ReinstateTeam,
      callback);
};


/**
 * @param {!proto.saufdings.ReinstateTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.Tournament>}
 *     Promise that resolves to the response
 */
proto.saufdings.PongerPromiseClient.prototype.reinstateTeam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.Ponger/ReinstateTeam',
      request,
      metadata || {},
      methodDescriptor_Ponger_ReinstateTeam);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.AdvanceTournamentRequest,
 *   !proto.saufdings.Tournament>}
 */
const methodDescriptor_Ponger_AdvanceTournament = new grpc.web.MethodDescriptor(
  '/saufdings.Ponger/AdvanceTournament',
  grpc.web.MethodType.UNARY,
  proto.saufdings.AdvanceTournamentRequest,
  proto.saufdings.Tournament,
  /**
   * @param {!proto.saufdings.AdvanceTournamentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.Tournament.deserializeBinary
);


/**
 * @param {!proto.saufdings.AdvanceTournamentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.Tournament)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.Tournament>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.PongerClient.prototype.advanceTournament =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.Ponger/AdvanceTournament',
      request,
      metadata || {},
      methodDescriptor_Ponger_AdvanceTournament,
      callback);
};


/**
 * @param {!proto.saufdings.AdvanceTournamentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.Tournament>}
 *     Promise that resolves to the response
 */
proto.saufdings.PongerPromiseClient.prototype.advanceTournament =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.Ponger/AdvanceTournament',
      request,
      metadata || {},
      methodDescriptor_Ponger_AdvanceTournament);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.DeleteTournamentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Ponger_DeleteTournament = new grpc.web.MethodDescriptor(
  '/saufdings.Ponger/DeleteTournament',
  grpc.web.MethodType.UNARY,
  proto.saufdings.DeleteTournamentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.saufdings.DeleteTournamentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.saufdings.DeleteTournamentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.PongerClient.prototype.deleteTournament =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.Ponger/DeleteTournament',
      request,
      metadata || {},
      methodDescriptor_Ponger_DeleteTournament,
      callback);
};


/**
 * @param {!proto.saufdings.DeleteTournamentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.saufdings.PongerPromiseClient.prototype.deleteTournament =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.Ponger/DeleteTournament',
      request,
      metadata || {},
      methodDescriptor_Ponger_DeleteTournament);
};


module.exports = proto.saufdings;
